import { LEARNING_PRODUCTS, PRODUCT_TYPES } from 'bundles/search-common/constants';
import ROUTE_CONFIG from 'bundles/unified-description-page-common/constants/routeConfig';

/**
 * Builds an org-scoped product link for enterprise XDPs.
 * Org-scoped equivalent of `getProgramLinkFromProductType` from collections-carousel.
 *
 * @param orgSlug - The organization slug
 * @param slug - The product slug (course slug, s12n slug, etc.)
 * @param productType - The product type (from PRODUCT_TYPES or LEARNING_PRODUCTS constants)
 * @param queryParams - Optional query params to append (e.g., programId, collectionId)
 */
export const getOrgScopedProductLink = (
  orgSlug: string,
  slug: string,
  productType?: string,
  queryParams?: Record<string, string>
) => {
  let path: string;

  switch (productType) {
    case PRODUCT_TYPES.Course:
    case LEARNING_PRODUCTS.Course:
    case 'course':
      path = `/organizations/${orgSlug}/${ROUTE_CONFIG.COURSE.pathname}/${slug}`;
      break;
    case PRODUCT_TYPES.Specialization:
    case LEARNING_PRODUCTS.Specialization:
    case 's12n':
      path = `/organizations/${orgSlug}/${ROUTE_CONFIG.SPECIALIZATIONS.pathname}/${slug}`;
      break;
    case PRODUCT_TYPES.ProfessionalCertificate:
    case LEARNING_PRODUCTS.ProfessionalCertificate:
    case 'profS12n':
      path = `/organizations/${orgSlug}/${ROUTE_CONFIG.PROFESSIONAL_CERTIFICATES.pathname}/${slug}`;
      break;
    case PRODUCT_TYPES.Project:
    case PRODUCT_TYPES.GuidedProject:
    case LEARNING_PRODUCTS.Project:
    case LEARNING_PRODUCTS.GuidedProject:
    case 'project':
      path = `/organizations/${orgSlug}/${ROUTE_CONFIG.PROJECTS.pathname}/${slug}`;
      break;
    case PRODUCT_TYPES.Video:
    case LEARNING_PRODUCTS.Video:
    case 'video':
    case 'clip':
      path = `/videos/${slug}`;
      break;
    default:
      path = `/organizations/${orgSlug}`;
      break;
  }

  if (queryParams && Object.keys(queryParams).length > 0) {
    const searchParams = new URLSearchParams(queryParams);
    return `${path}?${searchParams.toString()}`;
  }

  return path;
};
